var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Trans, useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getLanguageFromStorage } from "syf-js-utilities";
import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons";
import { Container, FaqLink, RewardsTermsLink, Text, TextContainer, TitleContainer, } from "./subcomponents";
var DEFAULT_REWARDS_TERMS_KEY_TRANSLATION = "faqs.description";
var RewardsFaqs = function (_a) {
    var className = _a.className, client = _a.client, rewardsExperience = _a.rewardsExperience;
    var t = useTranslation().t;
    var lang = getLanguageFromStorage();
    var dataType = className === "inside-drawer" ? "rewards snapshot" : "rewards";
    var termsTranslationKey = rewardsExperience[client].translationKey;
    var faqs = rewardsExperience[client].faqs;
    var termsAndConditionsLink = rewardsExperience[client][lang].termsAndConditionsLink;
    var rewardsTermsLink = (_jsx(RewardsTermsLink, { href: termsAndConditionsLink, target: "_blank", "data-type": dataType, "data-reason": "rewards program terms", "data-object": "link", "data-analytics": "clicktrackingevent" }));
    return (_jsxs(Container, __assign({ "data-testid": "rewards-faqs-component", className: className }, { children: [faqs && (_jsxs(TitleContainer, __assign({ className: className }, { children: [_jsx(FontAwesomeIcon, { icon: faCircleQuestion }), faqs && (_jsx(FaqLink, __assign({ href: faqs, target: "_blank", "data-type": dataType, "data-reason": "rewards faqs", "data-object": "link", "data-analytics": "clicktrackingevent" }, { children: t("faqs.faqLinkText") })))] }))), termsAndConditionsLink && (_jsx(TextContainer, { children: _jsx(Text, __assign({ className: "faqs-text" }, { children: _jsx(Trans, { i18nKey: dataType === "rewards snapshot"
                            ? DEFAULT_REWARDS_TERMS_KEY_TRANSLATION
                            : termsTranslationKey, components: { a: rewardsTermsLink } }) })) }))] })));
};
export default RewardsFaqs;
